import React from 'react'
import { useTranslation } from 'react-i18next'
import { DashboardWidget } from 'features/widget/types'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { useDashboardWidgetData } from '../../../../../hooks/useWidgetState'
import ErrorMessage from '../../../../share/ErrorMessage'

const isEmptyResult = (widgetData: DashboardWidget<AnnotatedMetricResult>) => {
  const entries = widgetData!.data![0]!.results![0]!.data!.metrics!
  const sum = entries
    .flatMap((entry) => entry.dataset)
    .flatMap((entry) => entry!.set)
    .reduce((prev, curr) => prev! + curr!, 0)
  return sum === 0
}

const SourceAreaEmptyResultGuard = ({
  widgetId,
  children
}: {
  widgetId: number
  children: React.ReactElement
}) => {
  const widgetData = useDashboardWidgetData<AnnotatedMetricResult>(widgetId)
  const { t } = useTranslation()

  if (isEmptyResult(widgetData)) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }

  return children
}

export default SourceAreaEmptyResultGuard
